export default __webpack_public_path__ + "locales/fr/Files.json?hash=21c6a63acf443069b1630447638ed447";